function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#BAEAFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.9231 10H14.2308C13.2764 10 12.5 10.7764 12.5 11.7308V28.2693C12.5 29.2236 13.2764 30 14.2308 30H26.9231C27.2417 30 27.5 29.7417 27.5 29.4231V10.5769C27.5 10.2583 27.2417 10 26.9231 10ZM15.3846 12.5H24.6154C24.934 12.5 25.1923 12.7583 25.1923 13.0769C25.1923 13.3955 24.934 13.6538 24.6154 13.6538H15.3846C15.066 13.6538 14.8077 13.3955 14.8077 13.0769C14.8077 12.7583 15.066 12.5 15.3846 12.5ZM15.3846 15.5769H20.0192C20.3379 15.5769 20.5961 15.8352 20.5961 16.1538C20.5961 16.4724 20.3378 16.7307 20.0192 16.7307H15.3846C15.066 16.7307 14.8077 16.4724 14.8077 16.1538C14.8077 15.8352 15.066 15.5769 15.3846 15.5769ZM26.3462 28.8462H14.2308C13.9127 28.8462 13.6539 28.5874 13.6539 28.2693V27.5H26.3462V28.8462Z",
  fill: "#4A87A0"
});

var SvgPurchaserequest = function SvgPurchaserequest(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPurchaserequest, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/purchaserequest.24b6eae6.svg";
export { ForwardRef as ReactComponent };